<template>
  <el-empty v-if="!loading && !order" description="没有找到订单信息..." />
  <div v-else class="wrap">
    <!--操作提示区-->
    <div class="tip primary">
      <dl class="text-info text-sm">
        <dt class="text-warning">
          <i class="el-icon-bell" />
          操作提示
        </dt>
        <dd>商品设置信息默认沿用上次订单的设定，在订单审核前可以重新设置。</dd>
        <dd>页面打印建议：根据数据行数量，A4纵向打印/A5横向打印。</dd>
      </dl>
      <div class="btns">
        <el-link
          type="primary"
          v-action="'/api/Mall/Order/Approval'"
          v-if="order.State == 1"
          @click="onApprove()"
          >审核
        </el-link>
        <el-link type="primary" @click="drawer = !drawer">操作记录</el-link>
        <el-link type="primary" v-print="printObj"
          >打印[{{ order.Printime || 0 }}次]</el-link
        >
      </div>
    </div>

    <!--审核记录-->
    <applys mode="Mall-order" :target="order.Id" />

    <div class="paper" id="print">
      <!--打印区-->
      <table v-for="(g, gi) in order.Items" :key="'tb_' + gi">
        <thead>
          <tr>
            <td colspan="8" class="title">
              <vue-qr class="qr" :margin="0" :text="order.Code" :size="64" />
              <div class="text-center">
                <h1>{{ $utils.meta.format("branch", order.Type) }}销售订单</h1>
                <p class="text-danger text-lg">
                  NO.{{ order.Code }}
                  <template v-if="order.Items.length > 1"
                    >/{{ gi + 1 }}</template
                  >
                </p>
              </div>
              <div class="order">
                <ul>
                  <li>
                    <label>客户名称：{{ order.CustomerName }}</label>
                  </li>
                  <li>
                    <label>联系人：{{ order.Linkman }}</label>
                    <label>联系电话：{{ order.Linktel }}</label>
                  </li>
                  <li>
                    <label>收货地址：{{ order.Address }}</label>
                  </li>
                  <li>
                    <label
                      >下单时间：{{
                        $utils.common.parseTime(
                          order.CreateTime,
                          "{y} 年 {m} 月 {d} {h}:{i}"
                        )
                      }}</label
                    >
                  </li>
                </ul>
                <ul>
                  <li style="white-space: nowrap">
                    <label>{{ g[0] || "" }}</label>
                    <label>{{ order.StateText }}</label>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>存货编码</th>
            <th colspan="3">品名及规格</th>
            <th>单位</th>
            <th>数量</th>
            <th>单价</th>
            <th>金额</th>
          </tr>
          <template v-for="(item, index) in g[1]">
            <tr :key="'tr' + index">
              <th>
                {{ $utils.meta.format("branch", item.Stock) }}
                {{ item.Code }}
              </th>
              <td colspan="3">
                {{ item.Name }}
                <el-tag
                  v-if="order.State != 9"
                  v-action="'/api/Mall/Order/Setting'"
                  @click="onSetting(item)"
                  effect="plain"
                  size="mini"
                  type="danger"
                  class="no-print"
                  >设置</el-tag
                >
              </td>
              <th>{{ item.Unit }}</th>
              <th>{{ item.Amount }}</th>
              <th class="text-price" :rowspan="item.Subitems.length + 1">
                {{ item.Price }}
              </th>
              <th class="text-price" :rowspan="item.Subitems.length + 1">
                {{ item.Price * item.Amount }}
              </th>
            </tr>
            <tr
              v-for="(sub, _index) in item.Subitems"
              :key="`${index}${_index}`"
            >
              <th>
                {{ $utils.meta.format("branch", sub.Stock) }}
                {{ sub.Code }}
              </th>
              <td colspan="3" style="text-indent: 2em">{{ sub.Name }}</td>
              <th>{{ sub.Unit }}</th>
              <th>{{ sub.Amount }}</th>
            </tr>
          </template>
          <tr class="blank">
            <th></th>
            <td colspan="3"></td>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <th>合计</th>
            <td colspan="6">
              {{ $utils.common.formatCnmoney(order.Amount || 0) }}
            </td>
            <th class="text-price">{{ order.Amount || 0 }}</th>
          </tr>
          <tr style="height: 64px">
            <th>备注</th>
            <td colspan="7" class="text-space" style="vertical-align: top">
              {{ order.Code }}_{{ order.Remark }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="2">审核：</td>
            <td colspan="2">财务：</td>
            <td colspan="2">部门经理：</td>
            <td colspan="2">经办人：</td>
          </tr>
        </tfoot>
      </table>

      <!--发货情况-->
      <table
        class="no-print"
        style="min-height: unset"
        v-if="parcels.length > 0"
      >
        <thead>
          <tr>
            <td colspan="8">
              <h2>订单发货记录</h2>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>库存编码</th>
            <td colspan="3">品名及规格</td>
            <th>单位</th>
            <th>数量</th>
            <th colspan="2">发货情况</th>
          </tr>
          <tr v-for="(item, index) in parcels" :key="index">
            <th>
              {{ $utils.meta.format("branch", item.Stock) }}
              {{ item.GoodCode }}
            </th>
            <td colspan="3">{{ item.Name }}</td>
            <th>{{ item.Unit }}</th>
            <th>{{ item.Amount }}</th>
            <td colspan="2">
              {{ $utils.meta.format("courier", item.Courier) }}
              {{ item.ParcelCode }}
              {{ item.State }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--操作记录-->
    <el-drawer
      v-if="order.Id"
      title="操作记录"
      :visible.sync="drawer"
      append-to-body
    >
      <records type="Mall-Order" :id="order.Id" />
    </el-drawer>
  </div>
</template>

<script>
import settingForm from "./setting.vue";
import applyForm from "@/views/company/audit/apply.vue";
import approveForm from "./approve.vue";

export default {
  components: {
    vueQr: () => import("vue-qr"),
    records: () => import("@/views/system/record/list"),
    applys: () => import("@/views/company/audit/_record.vue"),
  },
  props: {
    id: { Type: String },
  },
  data() {
    return {
      loading: false,
      drawer: false,
      order: null,
      parcels: null,
      printObj: {
        id: "#print",
        closeCallback: this.onPrintime,
      },
    };
  },
  created() {
    this.loadData(this.$route.params?.id || this.id);
  },
  methods: {
    onPrintime() {
      this.$confirm(null, "是否记录本次打印信息?", {
        type: "warning",
        center: true,
      }).then(() => {
        this.$apis.mall.order
          .printime({
            id: this.order.Id,
          })
          .then(() => {
            this.order.Printime += 1;
          });
      });
    },

    loadData(id) {
      if (!id || this.loading) {
        return;
      }
      this.loading = true;
      this.$apis.mall.order
        .info({
          id: id,
        })
        .then((res) => {
          res.Items = this.dataGroup(res.Items);
          this.order = res;
          return this.$apis.mall.order.item.parcels({ order: id });
        })
        .then((res) => {
          this.parcels = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //分组方法
    dataGroup(list) {
      const map = new Map();
      list.forEach((item, index, arr) => {
        map.set(
          item.Dept + item.User,
          arr.filter((a) => a.Dept == item.Dept && a.User == item.User)
        );
      });
      return Array.from(map);
    },

    //审核
    onApprove() {
      this.$layer.iframe({
        title: `订单审核`,
        area: ["400px", "auto"],
        content: {
          content: approveForm,
          parent: this,
          data: {
            id: this.order.Id,
            callback: (res) => {
              if (res) {
                this.loadData(this.order.Id);
              } else {
                this.onApply();
              }
            },
          },
        },
      });
    },

    //转审
    onApply() {
      this.$layer.iframe({
        title: `订单转审`,
        area: ["400px", "auto"],
        content: {
          content: applyForm,
          parent: this,
          data: {
            id: this.order.Id,
            msg: `${this.order.CustomerName}订单${this.order.Code}申请审核`,
            mode: "Mall-Order",
            callback: () => {
              this.loadData(this.order.Id);
            },
          },
        },
      });
    },

    //设置
    onSetting(row) {
      this.$layer.iframe({
        title: row.Name.substr(0, 10),
        area: ["360px", "auto"],
        content: {
          content: settingForm,
          parent: this,
          data: {
            _form: {
              Id: row.Id,
              Price: row.Price,
              DeptId: null,
              UserId: null,
              UserName: null,
            },
            callback: () => {
              this.loadData(this.order.Id);
            },
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .tip {
    position: relative;

    .btns {
      position: absolute;
      right: 30px;
      bottom: 30px;
    }
  }

  .paper {
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 48px;

    table {
      flex: 1;
      min-width: 720px;
    }

    table + table {
      margin-top: 48px;
    }
  }
}

//输出到打印页面
@media print {
  .no-print {
    display: none;
  }
}

h1 {
  font-size: 24px;
}

.paper {
  height: 100%;

  table {
    page-break-after: always;
    height: 100%;
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    border: 1px solid transparent;
    font-size: 12px;

    tr {
      th,
      td {
        word-break: break-all;
        font-weight: normal;
        height: 30px;
        padding: 5px 10px;
      }

      &.blank {
        height: inherit;
      }
    }

    tbody {
      height: 100%;

      tr {
        td,
        th {
          border: 1px solid #000;
        }
      }
    }

    .title {
      position: relative;

      .order {
        margin-top: 20px;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        ul {
          white-space: nowrap;

          li {
            list-style: none;
            display: flex;
            flex-direction: row;
            align-items: center;

            label:nth-child(odd) {
              flex-shrink: 0;
            }

            label {
              flex: 1;
            }

            label + label {
              margin-left: 20px;
            }
          }

          li + li {
            margin-top: 5px;
          }
        }
      }

      .qr {
        position: absolute;
        right: 0px;
        top: 0px;
      }
    }
  }
}
</style>
